import React from "react";
import { Link } from "react-router-dom";

const Workplace = ({ onMenuClick, active }) => {
  return (
    <>
      <li className="nav-item">
        <Link
          to
          className={`nav-link with-sub ${
            active === "/region" || active === "/area" || active === "/base" || active === "/route" ? "active show-sub" : ""
          }`}
        >
          <i className="fa fa-briefcase" aria-hidden="true"></i>
          <span>Project Management</span>
        </Link>
        <ul className="nav-sub">
          {/* Project */}
          <li className="nav-item">
            <Link
              to="/list-project"
              className={`nav-link ${active === "/list-project" ? "active" : ""}`}
              onClick={() => onMenuClick("/list-project")}
            >
              <i className="fa fa-clone" aria-hidden="true"></i>
              &nbsp;&nbsp; Projects
            </Link>
          </li>

          {/* Task Type */}
          <li className="nav-item">
            <Link
              to="/list-type-task"
              className={`nav-link ${active === "/list-type-task" ? "active" : ""}`}
              onClick={() => onMenuClick("/list-type-task")}
            >
              <i className="fa fa-clone" aria-hidden="true"></i>
              &nbsp;&nbsp; Task Type
            </Link>
          </li>

          {/* Label */}
          <li className="nav-item">
            <Link to="/list-label" className={`nav-link ${active === "/list-label" ? "active" : ""}`} onClick={() => onMenuClick("/list-label")}>
              <i className="fa fa-clone" aria-hidden="true"></i>
              &nbsp;&nbsp; Label
            </Link>
          </li>

          {/* Story */}
          <li className="nav-item">
            <Link to="/list-story" className={`nav-link ${active === "/list-story" ? "active" : ""}`} onClick={() => onMenuClick("/list-story")}>
              <i className="fa fa-clone" aria-hidden="true"></i>
              &nbsp;&nbsp; Story
            </Link>
          </li>

          {/* Sprint */}
          <li className="nav-item">
            <Link to="/sprint-list" className={`nav-link ${active === "/sprint-list" ? "active" : ""}`} onClick={() => onMenuClick("/sprint-list")}>
              <i className="fa fa-calendar" aria-hidden="true"></i>
              &nbsp;&nbsp; Sprint
            </Link>
          </li>

          {/* Sprint Planning */}
          <li className="nav-item">
            <Link
              to="/sprint-planning"
              className={`nav-link ${active === "/sprint-planning" ? "active" : ""}`}
              onClick={() => onMenuClick("/sprint-planning")}
            >
              <i className="fa fa-tasks" aria-hidden="true"></i>
              &nbsp;&nbsp; Sprint Planning
            </Link>
          </li>

          {/* Task */}
          <li className="nav-item">
            <Link to="/list-task" className={`nav-link ${active === "/list-task" ? "active" : ""}`} onClick={() => onMenuClick("/list-task")}>
              <i className="fa fa-clone" aria-hidden="true"></i>
              &nbsp;&nbsp; Task
            </Link>
          </li>

          {/* Backlog (replacing separate Story and Task) */}
          <li className="nav-item">
            <Link to="/backlog" className={`nav-link ${active === "/backlog" ? "active" : ""}`} onClick={() => onMenuClick("/backlog")}>
              <i className="fa fa-list" aria-hidden="true"></i>
              &nbsp;&nbsp; Backlog
            </Link>
          </li>

          {/* Project Board */}
          <li className="nav-item">
            <Link
              to="/list-project-board"
              className={`nav-link ${active === "/list-project-board" ? "active" : ""}`}
              onClick={() => onMenuClick("/list-project-board")}
            >
              <i className="fa fa-clone" aria-hidden="true"></i>
              &nbsp;&nbsp; Project Board
            </Link>
          </li>

          {/* Task Calendar */}
          <li className="nav-item">
            <Link
              to="/task-calendar"
              className={`nav-link ${active === "/task-calendar" ? "active" : ""}`}
              onClick={() => onMenuClick("/task-calendar")}
            >
              <i className="fa fa-calendar" aria-hidden="true"></i>
              &nbsp;&nbsp; Task Calendar
            </Link>
          </li>

          {/* Developer Task History */}
          <li className="nav-item">
            <Link
              to="/developer-task-history"
              className={`nav-link ${active === "/developer-task-history" ? "active" : ""}`}
              onClick={() => onMenuClick("/developer-task-history")}
            >
              <i className="fa fa-history" aria-hidden="true"></i>
              &nbsp;&nbsp; Developer Task History
            </Link>
          </li>
        </ul>
      </li>
    </>
  );
};

export default Workplace;
